import AdminClient from '../client/AdminClient';

class PhoneService {
    static phoneValidationEndpoint = '/v1/admin/phones';

    static async validate(session, params={}) {
        return AdminClient.post(`${this.phoneValidationEndpoint}/validate`, session, {phone: params})
    }
}
export default PhoneService;